import { useState } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
import { getOSData } from "../OSDetection";
export function useDetectOS() {
    const [OSData, setOSData] = useState({});
    useIsomorphicLayoutEffect(() => {
        const detectedOSData = getOSData();
        setOSData(detectedOSData);
    }, []);
    return OSData;
}
